/** @internal */
export type Direction = 'ltr' | 'rtl';

/**
 * Array of supported units to specify the size of a panel.
 * @public
 */
export const panelSizeUnits = ['px', 'fr', '%', 'vw', 'rem'] as const;
/**
 * The supported units to specify the size of a panel.
 * @public
 */
export type PanelSizeUnit = (typeof panelSizeUnits)[number];

/**
 * The size of a panel.
 * @public
 */
export type PanelSize = number | `${number}${PanelSizeUnit}`;
